function needDocs() {
  var bool = common.configData.docScanRequired;
  if (bool === true || bool === false) {
    return bool
  } else {
    return false;
  }
};

function docAgeRequired() {
  var age = common.configData.docAgeRequired;
  if (age && age !== 0) {
    return age;
  } else {
    return null;
  }
};

function triggerUpload(docType) {
  $('#' + docType + 'Upload').click();
}

function updateDocWarning(memberGuid) {
  if (checkRequiredDoc(memberGuid)) {
    if ($('.required-documents-warning').hasClass('reqDocShown')) {
      $('.required-documents-warning').removeClass('reqDocShown');
      $('.required-documents-warning').addClass('reqDocHidden');
      $('.required-documents-success').removeClass('reqDocHidden');
      $('.required-documents-success').addClass('reqDocShown');
      $('#operator-input').prop('disabled', '');
      $('#chairstart2').prop('disabled', '');
    }
  } else {
    $('.required-documents-warning').removeClass('reqDocHidden');
    $('.required-documents-warning').addClass('reqDocShown');
    $('.required-documents-success').removeClass('reqDocShown');
    $('.required-documents-success').addClass('reqDocHidden');
    if (needDocs()) {
      $('#operator-input').prop('disabled', 'disabled');
      $('#chairstart2').prop('disabled', 'disabled');
    }
  }
}

function checkMemberAge(memberGuid, age = null, birthdate = null) {
  if (age == null && birthdate == null) {
    $.ajax({
      async: false,
      method: "GET",
      headers: {
        Accept: "application/json; charset=utf-8"
      },
      retryCall: false,
      timeout: 20000,
      data: {
        "memberGuid": memberGuid
      },
      url: config.MEMBER_SERVICE + "/Member/Id",
      success: function (data) {
        age = moment().diff(data.members[0].birthDate, 'years');
      },
      error: function (jqXHR, textStatus, errorThrown) {
        var err;
        if (jqXHR && jqXHR.responseJSON && jqXHR.responseJSON.message) {
          // err = jqXHR.responseJSON.message;
          err = 'jqXHR.responseJSON.message 107';
        } else {
          err = 'There was a problem accessing the member service, please try your request again or contact a system administrator.';
        }
        common.showError(null, null, err);
      }
    });
  }
  if (birthdate) {
    age = moment().diff(birthdate, 'years');
  }

  if (docAgeRequired()) {
    var ageRequired = docAgeRequired();
    if (age > ageRequired) {
      return false;
    } else {
      return ageRequired;
    }
  } else {
    return false
  }
}

// Takes an uploaded image file and displays a preview of the image while storing it's base64 for saving later.
function previewFile(docType, refresh = false) {
  var preview = document.getElementById(docType + 'Preview'); //selects the query named img
  var file = document.getElementById(docType + 'Upload').files[0]; //sames as here
  var fileURL = localStorage.getItem('pf-doc-' + docType);
  var reader = new FileReader();

  reader.onloadend = function () {
    preview.src = reader.result;
    // console.log(reader.result)
    localStorage.setItem('pf-doc-' + docType, reader.result);
    var docSet = localStorage.getItem('pf-doc-set');
    if (docSet) {
      docSet = docSet + ',' + docType
      localStorage.setItem('pf-doc-set', docSet);
    } else {
      docSet = docType
      localStorage.setItem('pf-doc-set', docSet);
    }
  }

  if (file && refresh === false) {
    reader.readAsDataURL(file);
    preview.style.display = 'block';
    $('.' + docType + '-wrapper').addClass('doc-found')
  } else if (fileURL) {
    preview.src = fileURL;
    preview.style.display = 'block';
    $('.' + docType + '-wrapper').addClass('doc-found')
  } else {
    preview.style.display = 'none';
    preview.src = "";
    $('.' + docType + '-wrapper').removeClass('doc-found')
  }
}

function triggerUpdate(docType) {
  var $docUpdateModal = $('#requiredDocumentsRemovalModal');
  $docUpdateModal.attr('data-docType', docType);
  $docUpdateModal.modal()
}

function reqDocUpdate() {
  var $docUpdateModal = $('#requiredDocumentsRemovalModal');
  var docType = $docUpdateModal.attr('data-docType');
  $docUpdateModal.modal('hide')
  $('#' + docType + 'Upload').click();
}

function reqDocSave(memberGuid) {
  common.showLoader(pfFetchTranslation('requiredDocuments.savingDocs'), 100, true);
  var docList = localStorage.getItem('pf-doc-set');
  if (docList) {
    if (docList.includes(',')) {
      var docListSplit = docList.split(',');
      docListSplit.forEach(element => {
        saveDoc(memberGuid, element);
      })
    } else {
      saveDoc(memberGuid, docList)
    };
  };
  updateDocWarning(memberGuid);
  $('#requiredDocumentsModal').modal('hide');
  common.hideLoader();
}

function saveDoc(memberGuid, docTypeName) {
  var params = 'memberGuid=' + memberGuid + '&docTypeName=' + docTypeName;
  var imageData = localStorage.getItem('pf-doc-' + docTypeName);
  $.ajax({
    async: false,
    method: 'POST',
    data: JSON.stringify(imageData),
    url: config.MEMBER_SERVICE + '/Member/DocImage?' + params,
    dataType: 'json',
    contentType: 'application/json; charset=utf-8',
    headers: {
      Accept: 'application/json; charset=utf-8'
    },
    success: function (res) {
      if (!res.documentUrl) {
        pfKioskServices.trackEvent({
          name: 'Document Save Failed',
          properties: {
            memberGuid: memberGuid,
            message: res.Message,
            docTypeName: docTypeName,
            imageData: imageData
          }
        });
      } else {
        pfKioskServices.trackEvent({
          name: 'Document Saved',
          properties: {
            memberGuid: memberGuid,
            documentUrl: res.documentUrl
          }
        });
      }
    },
    error: function (jqXHR, textStatus, errorThrown) {
      //onFail(jqXHR, textStatus, errorThrown);
    }
  });
};

function getRequiredDoc(memberGuid, docTypeName) {
  var clubId = common.configData.clubCode;
  var params = 'clubId=' + clubId + '&memberGuid=' + memberGuid + '&docTypeName=' + docTypeName;
  $.ajax({
    async: false,
    cache: false,
    method: 'GET',
    headers: {
      Accept: 'application/json; charset=utf-8'
    },
    url: config.MEMBER_SERVICE + '/Member/Photo?' + params,
    success: function (res) {
      if (!res.includes("Exception")) {
        localStorage.setItem('pf-doc-' + docTypeName, res);
        return true
      } else {
        localStorage.removeItem('pf-doc-' + docTypeName);
        if (document.getElementById(docTypeName + 'Preview')) {
          var preview = document.getElementById(docTypeName + 'Preview'); //selects the query named img
          preview.style.display = 'none';
          preview.src = "";
          $('.' + docTypeName + '-wrapper').removeClass('doc-found')
        }
        return false
      }
    },
    error: function (jqXHR, textStatus, errorThrown) {
      // onFail(jqXHR, textStatus, errorThrown);
    }
  });
}

function checkRequiredDoc(memberGuid) {
  removeRequiredDocs('governmentIssued');
  getRequiredDoc(memberGuid, 'governmentIssued');
  var gov = localStorage.getItem('pf-doc-governmentIssued');
  if (gov) {
    return true;
  } else {
    var documentList = [
      'ageVerification',
      'idVerification'
    ];
    documentList.forEach(function (document) {
      removeRequiredDocs(document);
      getRequiredDoc(memberGuid, document);
    })
    var age = localStorage.getItem('pf-doc-ageVerification')
    var id = localStorage.getItem('pf-doc-idVerification')
    if (age && id) {
      return true;
    } else {
      return false;
    }
  }
}

function loadRequiredDocs() {
  var documentList = [
    'governmentIssued',
    'ageVerification',
    'idVerification'
  ];
  documentList.forEach(function (docType) {
    var documentCode = localStorage.getItem('pf-doc-' + docType);
    if (documentCode) {
      previewFile(docType, true);
    } else {
      var preview = document.getElementById(docType + 'Preview'); //selects the query named img
      preview.style.display = 'none';
      preview.src = "";
      $('.' + docType + '-wrapper').removeClass('doc-found')
    };
  })

};

function removeRequiredDocs(documentList) {
  if (documentList) {
    if (typeof documentList === 'string') {
      documentList = [documentList];
    };
  } else {
    documentList = [
      'governmentIssued',
      'ageVerification',
      'idVerification'
    ];
  }
  documentList.forEach(function (docType) {
    localStorage.removeItem('pf-doc-' + docType);
    if (document.getElementById(docType + 'Upload')) {
      document.getElementById(docType + 'Upload').files = null;
      var preview = document.getElementById(docType + 'Preview'); //selects the query named img
      preview.style.display = 'none';
      preview.src = "";
      $('.' + docType + '-wrapper').removeClass('doc-found')
    }
  });
};
